var classes = {"cactus-input-footer__wrapper":"index-module_cactus-input-footer__wrapper__ZZZof","message-wrapper":"index-module_message-wrapper__en4-G","message":"index-module_message__rvr0G","size-small":"index-module_size-small__QwUBQ","weight-semibold":"index-module_weight-semibold__ffuZg","weight-book":"index-module_weight-book__LrImk","error":"index-module_error__utyyq"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
